const ROUTES = {
  WELCOME: '/WELCOME',
  LOGIN: '/login',
  // REPORTING
  DASHBOARD: '/reporting/dashboard',
  TRANSACTION: '/reporting/transaction',
  ACTIVE_MEMBERS: '/report/activeMembers',
  SESSION_ANALYSIS: '/report/sessionAnalysis',

  // PEOPLE
  MEMBER: '/people/member',
  MEMBER_UPDATE: '/people/member/update/:id',
  MEMBER_PROFILE: '/people/memberProfile',
  MEMBER_PROFILE_CREATE: '/people/memberProfile/create',
  MEMBER_PROFILE_UPDATE: '/people/memberProfile/update/:id',
  TIERS_MEMBERSHIP: '/people/tier-membership',
  SUBSCRIPTION: '/people/subscription',
  SUBSCRIPTION_CREATE: '/people/subscription/create',
  SUBSCRIPTION_UPDATE: '/people/subscription/update/:id',
  SUBSCRIPTION_DISPLAY_ORDER: '/people/subscription/display-order',
  STAFF: '/people/staff',
  USER_ROLES: '/people/user-role',

  //ENGAGE
  SYSTEM_NOTIFICATION: '/engage/system-notification',
  SYSTEM_NOTIFICATION_CREATE: '/engage/system-notification/create',
  SYSTEM_NOTIFICATION_UPDATE: '/engage/system-notification/update/:id',
  ENQUIRY: '/engage/enquiry',
  FAQ: '/engage/faq',
  SURVEY: '/engage/survey',
  SURVEY_CREATE: '/engage/survey/create',
  SURVEY_UPDATE: '/engage/survey/update/:id',
  SURVEY_REPORT: '/engage/survey/report/:id',
  SURVEY_REPORT_GENERATE: '/engage/survey/report/:id/generate',
  CHARITY: '/engage/charity',
  NOTIFICATION_SETTING: '/engage/notification-settings',
  EMAIL_TEMPLATES: '/engage/email-templates',
  CONFIRMATION: '/engage/confirmation',

  // ACTIONS
  CAMPAIGNS: '/actions/campaigns',
  CAMPAIGNS_CREATE: '/actions/campaigns/create',
  CAMPAIGNS_UPDATE: '/actions/campaigns/update/:id',
  FRIEND_REFERRAL_CONFIG: '/actions/friend-referral-config',
  FRIEND_REFERRAL: '/actions/friend-referral',
  POINT_RATIO_REWARDS: '/actions/point-ratio-rewards',
  REMINDER: '/actions/reminder',

  // SYSTEM SETUP
  POS_SETTINGS: '/system-setup/pos-settings',
  INTEGRATIONS: '/system-setup/integrations',
  FEATURE_CONTROL: '/system-setup/feature-control',

  // SYSTEM ADMIN
  APP_CONFIG: '/system-admin/app-config',
  APP_LAYOUT: '/system-admin/app-layout',
  COMPANY_PROFILE: '/system-admin/company-profile',
  LEGALS: '/system-admin/legals',
  INSTRUCTION: '/system-admin/instruction',
  LOCATION: '/system-admin/location',
  BP_CONFIG: '/system-admin/packpanel-config',

  // LOYALTY
  GIFT_CERTIFICATE: '/loyalty/gift-certificate',
  GIFT_CERTIFICATE_UPDATE: '/loyalty/gift-certificate/update/:id',
  VOUCHER: '/loyalty/voucher',
  VOUCHER_UPDATE: '/loyalty/voucher/update/:id',
  GAMES: '/loyalty/games',
  GAMES_CREATE: '/loyalty/games/create',
  GAMES_UPDATE: '/loyalty/games/update/:id',

  POS_PROMOTIONS: '/loyalty/PosPromotions',
  POS_PROMOTIONS_UPDATE: '/loyalty/PosPromotions/update/:id',

  LISTING: '/listing/:id',
  LISTING_CREATE: '/listing/:id/create',
  LISTING_UPDATE: '/listing/:type_id/update/:id',
  LISTING_DISPLAY_ORDER: '/listing/:id/displayorder/:venue_id',

  TICKET: '/product',
  TICKET_CREATE: '/product/create',
  TICKET_UPDATE: '/product/update/:id',

  QUESTION: '/question',
  QUESTION_CREATE: '/question/create',
  QUESTION_UPDATE: '/question/update/:id',
  ANSWER: '/answer',

  PRODUCT: '/specialProduct',
  PRODUCT_CREATE: '/specialProduct/create',
  PRODUCT_UPDATE: '/specialProduct/:id',

  TRANSACTION_DETAIL: '/transaction/:id',

  SETTING: '/setting',

  MEMBER_REPORT: '/report/membersReport',
  SYSTEM_REPORT: '/report/systemLog',
  GAMING_REPORT: '/report/gamingLog',
  BEPOZ_REPORT: '/report/bepozLog',

  MOBILE_WALLET: '/mobile-wallet',
  MOBILE_WALLET_IOS: '/mobile-wallet/ios',
  MOBILE_WALLET_ANDROID: '/mobile-wallet/android',
  REGISTRATION: '/mobile-wallet/registration',

  // CHARITY
  CHARITY_NOMINATIONS: '/charity/nominations',
  CHARITY_FIELD_CONFIG: '/charity/field-config',
  CHARITY_DISPLAY_ORDER: '/charity/display-order/:venue_id',
}
export default ROUTES
